import { redirect } from 'client/actions/redirect';
import { getQuery } from 'client/utils/location';
import { HTTP_REDIRECT } from 'client/utils/http-status';
import { DEFAULT_IFRAME_URL } from 'site-modules/canvas/constants/canvas';

export const pageOptions = {
  name: 'chat_canvas_assistant',
  category: 'canvas',
  preload: (store, props) => {
    const state = store.getState();
    const query = getQuery(props?.location);

    const isCanvasDisabled = state?.featureFlags?.disableCanvas;
    if (isCanvasDisabled) {
      store.dispatch(
        redirect({
          path: decodeURIComponent(query?.page || DEFAULT_IFRAME_URL),
          status: HTTP_REDIRECT,
        })
      );
    }
  },
  seo: {
    title: 'Edmunds',
    robots: {
      noIndex: true,
      noFollow: true,
    },
  },
};
